<div class="mt-4 flex justify-center items-center  " *transloco="let t; read: 'user.company-profile'">
  <div class="flex flex-col gap-4 w-full md:w-2/3 xl:w-1/3">
    <h2 class="text-color-sun-yellow text-center">
      {{t('title')}}
    </h2>
    <div class="text-center text-blue1">
      {{t('subtitle')}}
    </div>
    <psc-loader *ngIf="loading"></psc-loader>
    <ng-container *ngIf="!loading">
      <psc-edit-company
        (companyUpserted)="companyChanged($event)"
        [companyType]="CompanyType.COMPANY"
        [hideCancel]="true"
        [owner]="true"
        [company]="company"></psc-edit-company>
    </ng-container>
  </div>

</div>
